export const MORE_LESS_CYCLES = [20, 36];
